export default __webpack_public_path__ + "static/media/404asset.5f7caaa7.png";